import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FilieraProvider } from "@/context/FilieraContext";
import Login from "@/pages/Login";
import AppLayout from "@/layout/AppLayout";
import Dashboard from "@/pages/Dashboard";
import { FilierePage, BeneficiariPage, InvestimentiPage, FornitoriPage, DocumentiPage, BonificiPage } from "@/pages/CrudPages";
import SalPage from "@/pages/SalPage";
import UploadAI from "@/pages/UploadAI";
import DocumentCenter from "@/pages/DocumentCenter";
import Export from "@/pages/Export";
import Utenti from "@/pages/Utenti";
import Compliance from "@/pages/Compliance";
import BatchUpload from "@/pages/BatchUpload";
import AuditLog from "@/pages/AuditLog";
import "@/App.css";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><FilieraProvider><AppLayout /></FilieraProvider></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/filiere" element={<FilierePage />} />
            <Route path="/beneficiari" element={<BeneficiariPage />} />
            <Route path="/investimenti" element={<InvestimentiPage />} />
            <Route path="/fornitori" element={<FornitoriPage />} />
            <Route path="/documenti" element={<DocumentiPage />} />
            <Route path="/bonifici" element={<BonificiPage />} />
            <Route path="/sal" element={<SalPage />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/batch-upload" element={<BatchUpload />} />
            <Route path="/audit-log" element={<AuditLog />} />
            <Route path="/document-center" element={<DocumentCenter />} />
            <Route path="/upload" element={<UploadAI />} />
            <Route path="/export" element={<Export />} />
            <Route path="/utenti" element={<Protected roles={["admin"]}><Utenti /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
